<template>
  <v-text-field
    v-show="show"
    :label="label || title"
    v-model="val"
    :rules="rules"
    :required="required||false"
    v-mask="mask"
    v-if="mask"
  ></v-text-field>
  <v-text-field
    v-show="show"
    :label="label || title"
    v-model="val"
    :rules="rules"
    :required="required||false"
    v-else
  ></v-text-field>
</template>

<script>
import {EventMixin} from '@/lib/mixins.js';

export default {
  mixins: [EventMixin],
  props: [
    'value',
    'name',
    'label',
    'title',
    'required',
    'mask'
  ],
  computed: {
    rules () {
      if(this.required) {
        return [
          v => !!v || this.label+' is required'
        ]
      }
      return [];
    },
    val: {
      get () {
        return _.get(this.value, this.name) || "";
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>
